/** @format */

import {PaymentProfilesList} from '../payment_profiles_list/payment_profiles_list';
import {PaymentsProvider, usePaymentsContext} from '../payments_context_provider';
import React, {useState, useEffect, useContext} from 'react';
import PaymentFormCredit from '../add_credit_profile_form';
import PaymentFormBank from '../add_bank_profile_form';
import {Input, Select} from '@sttark/design-system';
import {CopyButton, If} from 'frontier-utilities';
import {UserContext} from 'frontier-utilities';
import {Toast} from '@sttark/design-system';
import {Link} from 'react-router-dom';

// styles
import './view_and_add_payment_profile.scss';

const options = [
    {
        value: 'account_last_four',
        label: 'Last four'
    }
];

const Container = () => {
    const userCtx = useContext(UserContext);

    const {handleGetPaymentProfiles, state} = usePaymentsContext();

    const [searchFilterKey, setSearchFilterKey] = useState('account_last_four');
    const [filteredPaymentProfiles, setFilteredPaymentProfiles] = useState([]);
    const [searchFilterValue, setSearchFilterValue] = useState('');
    const [toast, setToast] = React.useState({
        isOpen: false,
        isDanger: false,
        message: ''
    });

    const handleSearchFilterKeyChange = key => {
        setSearchFilterKey(key);
    };

    const handleSearchFilterValueChange = value => {
        setSearchFilterValue(value);
        setFilteredPaymentProfiles(
            state.paymentProfiles.filter(profile => {
                return profile[searchFilterKey].includes(value);
            })
        );
    };

    useEffect(() => {
        setFilteredPaymentProfiles(state.paymentProfiles);
    }, [state.paymentProfiles]);

    const hasPaymentMethods = state.paymentProfiles.length > 0;

    const handleSuccessfulPaymentProfileSave = () => {
        handleGetPaymentProfiles();
        setToast({
            message: 'Payment profile saved successfully',
            isDanger: false,
            isOpen: true
        });
    };

    const hideToast = () => {
        setToast({
            isDanger: false,
            isOpen: false,
            message: ''
        });
    };

    return (
        <>
            <Toast
                danger={toast.isDanger}
                autoHideDuration={4000}
                isOpen={toast.isOpen}
                onClose={hideToast}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">{toast.message}</p>
            </Toast>
            <div className="view-and-add-payment-98lw">
                <Link to="/account/users/payments">
                    <div className="d-inline-flex align-items-center justify-content-center gap-2 mb-4">
                        <i
                            className="fa fa-caret-left color-structure-black"
                            style={{fontSize: 24}}
                        />
                        <h3 className="m-0 p-0">Payment Methods</h3>
                    </div>
                </Link>
                <div className="view-and-add-payment-98lw__container">
                    {/* filter payment methods */}
                    <div className="d-flex align-items-center justify-content-center w-100">
                        <Select
                            className="view-add-05kt__select mr-4"
                            onChange={handleSearchFilterKeyChange}
                            placeholder="Select Payment method"
                            initialValue={'Last four'}
                            options={options}
                            label=""
                        />
                        <Input
                            onChange={handleSearchFilterValueChange}
                            className="view-add-05kt__input w-100"
                            placeholder="Search a payment method"
                            value={searchFilterValue}
                            label=""
                        />
                        <div className="d-flex align-items-center justify-content-end">
                            <PaymentFormCredit
                                onSuccessfulSave={handleSuccessfulPaymentProfileSave}>
                                <button className="flex-shrink-0 btn btn--primary py-1 view-add-05kt__btn">
                                    <b>Add Credit Card</b>
                                </button>
                            </PaymentFormCredit>
                            <If condition={userCtx.is_net_30}>
                                <PaymentFormBank
                                    onSuccessfulSave={handleSuccessfulPaymentProfileSave}>
                                    <button className="flex-shrink-0 btn btn--primary py-1 view-add-05kt__btn">
                                        <b>Add ACH</b>
                                    </button>
                                </PaymentFormBank>
                            </If>
                        </div>
                    </div>
                    {/* company account */}
                    <If condition={userCtx.is_net_30}>
                        <div className="view-and-add-payment-98lw__banking-info alert alert-secondary">
                            <h4 className="mb-2 mt-0 mx-0">
                                You can also send directly to our account:
                            </h4>
                            <div className="d-flex align-items-center justify-content-start gap-4">
                                <div>
                                    Account: 8010001019098 <CopyButton content="8010001019098" />
                                </div>
                                <div>
                                    Routing: 053200983 <CopyButton content="053200983" />
                                </div>
                            </div>
                        </div>
                    </If>
                    {/* payment methods */}
                    <If condition={!hasPaymentMethods}>
                        <div className="alert alert-info">No payment methods added yet!</div>
                    </If>

                    <If condition={hasPaymentMethods}>
                        <PaymentProfilesList paymentProfiles={filteredPaymentProfiles} />
                    </If>
                </div>
            </div>
        </>
    );
};

export const ViewAndAddPaymentProfile = () => {
    return (
        <PaymentsProvider>
            <Container />
        </PaymentsProvider>
    );
};
